import axios from "axios";

export const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    return (
      error.response?.data?.message ||
      error.message ||
      "An unexpected error has occurred. Please try again later."
    );
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "An unexpected error has occurred. Please try again later.";
};
